import {Autocomplete, Button, IconButton, Stack, TextField, useTheme} from "@mui/material";
import {useEffect, useState} from "react";
import {FiTrash2} from "react-icons/fi";
import {rolesColumns} from "../../constants/dataGridColumns";
import useApiRequest from "../../hooks/useApiRequest";
import useConfirmDialog from "../../hooks/useConfirmDialog";
import ListView from "../ListView/ListView";
import ConfirmDialog from "../ui/ConfirmDialog";

const UserRolesGrid = ({userId}) => {
  const theme = useTheme();
  const [isSettingNewRole, setIsSettingNewRole] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [rolesSelect, setRolesSelect] = useState([]);

  const {data, loading, list, remove, create} = useApiRequest({
    baseUrl: `/users/${userId}/roles`,
    resource: "users",
    field: "roles"
  });

  const {
    data: dataRoles,
    loading: loadingRoles,
    list: listRoles
  } = useApiRequest({baseUrl: `/roles`, resource: "roles"});

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
      await listRoles();
    } catch (error) {
      console.error("Error al eliminar el rol del usuario:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await list();
        await listRoles();
      } catch (error) {
        console.error("Error al cargar los roles del usuario:", error);
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (rolesSelect?.length === 0 && Array.isArray(dataRoles)) {
      if (Array.isArray(data) && data.length > 0) {
        const userRolesIds = data.map((role) => role.id);
        const rolesFiltered = dataRoles.filter((role) => !userRolesIds.includes(role.id));
        const transformedList = rolesFiltered.map((role) => ({
          id: role.id,
          label: role.name
        }));
        setRolesSelect(transformedList);
      } else {
        const transformedList = dataRoles.map((role) => ({
          id: role.id,
          label: role.name
        }));
        setRolesSelect(transformedList);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRoles, data]);

  const handleAccept = async () => {
    try {
      if (!selectedRoleId) return;
      const result = await create({role_id: selectedRoleId});

      if (result.success) {
        setRolesSelect((prev) => prev.filter((role) => role.id !== selectedRoleId));
      }
      await listRoles();
      await list();
    } catch (error) {
      console.error("Error al cargar los roles:", error);
    }

    //setIsSettingNewRole(!isSettingNewRole);
  };

  const handleRoleSelect = (event, value) => {
    setSelectedRoleId(value?.id || null);
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((role) => role.id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...rolesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDeleteDialog(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <ListView
        viewTitle={"Roles"}
        columns={columns}
        data={data || []}
        loading={loading || loadingRoles}
        topRightButtons={
          <Stack direction="row" spacing={2}>
            {isSettingNewRole && (
              <Stack direction="row" spacing={2}>
                <Autocomplete
                  disablePortal
                  options={rolesSelect}
                  sx={{
                    width: 300
                  }}
                  componentsProps={{
                    paper: {
                      sx: {
                        backgroundColor: theme.palette.colors.background,
                        color: theme.palette.text.primary
                      }
                    }
                  }}
                  onChange={handleRoleSelect}
                  renderInput={(params) => <TextField {...params} label="Rol" />}
                />
                <Button variant="contained" onClick={handleAccept}>
                  Aceptar
                </Button>
              </Stack>
            )}
            <Button
              variant="contained"
              color={isSettingNewRole ? "error" : "primary"}
              onClick={() => {
                setIsSettingNewRole(!isSettingNewRole);
              }}
            >
              {isSettingNewRole ? "Cancelar" : "Asignar rol"}
            </Button>
          </Stack>
        }
      />
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="rol"
        entityLabel={itemName}
      />
    </>
  );
};

export default UserRolesGrid;
